module.exports = __webpack_public_path__ + "static/IMG-2751-aaa5301b70a70294099827bb3160e0e0.jpg";